/**
 * In-app learn guides (JIM-1005-05, Jim 2026-10-05): a little book icon on a
 * page opens the same click-through pictures used to show him a feature —
 * "click on this, then you do this, and that's how you get this done". Not
 * timed, not video. Pictures live under /learn/<guide>/ and are retaken when
 * a page changes.
 */
export type GuideStep = {
  title: string;
  text: string;
  /** Path under the site root. */
  image: string;
};

export type Guide = {
  id: string;
  title: string;
  steps: GuideStep[];
};

export const GUIDES: Record<string, Guide> = {
  schedule: {
    id: 'schedule',
    title: 'Your week',
    steps: [
      {
        title: 'The week at a glance',
        text: 'The counters show what is overdue, due this week and unclaimed. Each day lists its sites; tap a day to open it.',
        image: '/learn/schedule/schedule-1-week.png',
      },
      {
        title: 'A day',
        text: 'Each site on a day has Start, Directions, a move-day button and Remove. Auto means the week built it from last week; Added means someone put it there.',
        image: '/learn/schedule/schedule-2-day.png',
      },
      {
        title: 'Put the day in order',
        text: 'The arrows on the left move a site up or down. Next week starts from the order you drove it.',
        image: '/learn/schedule/schedule-3-move.png',
      },
      {
        title: 'Move a site to another day',
        text: 'The swap button picks another weekday. Tick "Every week from now on" to make that its standing day.',
        image: '/learn/schedule/schedule-4-due.png',
      },
      {
        title: 'Start the inspection',
        text: 'Start opens the inspection for that site. Tapping the site name opens its details instead.',
        image: '/learn/schedule/schedule-5-start.png',
      },
    ],
  },
};
